module.exports = __webpack_public_path__ + "img/card-input.b8aa3c55.png";